import { create } from "zustand";
import { ReactNode } from "react";
// Define the Zustand store for SideSheet

interface IContent {
  body: ReactNode,
  title: string
  dataTestId?: string;
  onClose?: () => void;
}

interface SideSheetState {
  isOpen: boolean;
  isCollapsed: boolean;
  content: IContent | null;
  extendedWidth: boolean;
  openSideSheet: (content: any) => void;
  closeSideSheet: () => void;
  setExtendedWidth:(extendedWidth:boolean) => void;
}

// Create Zustand store
export const useSideSheetStore = create<SideSheetState>((set, get) => ({
  isOpen: false,
  isCollapsed: true,
  content: null,
  extendedWidth:false,
  setExtendedWidth:(extendedWidth) => set({extendedWidth}),
  openSideSheet: (content) => set({
    isOpen: true,
    isCollapsed: false,
    content,
    extendedWidth: false,
  }),
  closeSideSheet: () => {
    const { content } = get();
    set({ isOpen: false, isCollapsed: true, content: null, extendedWidth: false });
    content?.onClose?.();
  },
}));
